import { render, staticRenderFns } from "./NotificationsBanner.vue?vue&type=template&id=8ca9f2a2&scoped=true"
import script from "./NotificationsBanner.vue?vue&type=script&lang=js"
export * from "./NotificationsBanner.vue?vue&type=script&lang=js"
import style0 from "./NotificationsBanner.vue?vue&type=style&index=0&id=8ca9f2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca9f2a2",
  null
  
)

export default component.exports